export type SignaturePad = {
  hasInk: () => boolean;
  clear: () => void;
  toDataUrl: () => string;
};

export function createSignaturePad(canvas: HTMLCanvasElement): SignaturePad {
  let drawing = false;
  let ink = false;
  let last: { x: number; y: number } | null = null;

  const resize = () => {
    const saved = ink ? canvas.toDataURL('image/png') : '';
    const rect = canvas.getBoundingClientRect();
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = Math.max(600, Math.floor(rect.width * ratio));
    canvas.height = Math.max(220, Math.floor(rect.height * ratio));
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    if (saved) {
      const image = new Image();
      image.onload = () => ctx.drawImage(image, 0, 0, rect.width, rect.height);
      image.src = saved;
    }
  };

  const point = (event: PointerEvent) => {
    const rect = canvas.getBoundingClientRect();
    return { x: event.clientX - rect.left, y: event.clientY - rect.top };
  };

  canvas.addEventListener('pointerdown', (event) => {
    event.preventDefault();
    drawing = true;
    last = point(event);
    canvas.setPointerCapture(event.pointerId);
  });

  canvas.addEventListener('pointermove', (event) => {
    if (!drawing || !last) return;
    event.preventDefault();
    const next = point(event);
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.beginPath();
    ctx.moveTo(last.x, last.y);
    ctx.lineTo(next.x, next.y);
    ctx.stroke();
    last = next;
    ink = true;
  });

  const end = (event: PointerEvent) => {
    drawing = false;
    last = null;
    try { canvas.releasePointerCapture(event.pointerId); } catch { /* no-op */ }
  };
  canvas.addEventListener('pointerup', end);
  canvas.addEventListener('pointercancel', end);
  canvas.addEventListener('pointerleave', end);
  window.addEventListener('resize', resize);
  resize();

  return {
    hasInk: () => ink,
    clear: () => {
      const ctx = canvas.getContext('2d');
      if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
      ink = false;
    },
    toDataUrl: () => canvas.toDataURL('image/png'),
  };
}
